import { render, staticRenderFns } from "./maintainCustomer.vue?vue&type=template&id=1993cbea&scoped=true&"
import script from "./maintainCustomer.vue?vue&type=script&lang=js&"
export * from "./maintainCustomer.vue?vue&type=script&lang=js&"
import style0 from "./maintainCustomer.vue?vue&type=style&index=0&id=1993cbea&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1993cbea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1993cbea')) {
      api.createRecord('1993cbea', component.options)
    } else {
      api.reload('1993cbea', component.options)
    }
    module.hot.accept("./maintainCustomer.vue?vue&type=template&id=1993cbea&scoped=true&", function () {
      api.rerender('1993cbea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/client/maintainCustomer/maintainCustomer.vue"
export default component.exports